/**
 * 
 * @param {Object} exception - exception object 
 * @returns {Error} custom exception for problems details
 */
function ProblemDetailsException(exception) {
  console.log(exception)
  if (!exception) {
    return new Error("Error occured but problem details response is empty");
  }
  const error = new Error(exception.detail || "Error");
  error.code = "PROBLEM_DETAILS";
  error.name = exception.title || "Problem details response";
  error.statusCode = exception.status || 500;
  error.invalidProperties = exception.errors || {};

  return error;
};

ProblemDetailsException.prototype = Error.prototype;

export default ProblemDetailsException;
